import React from "react";
import { motion } from "framer-motion";

const cardVariants = {
  offscreen: {
    y: 300
  },
  onscreen: {
    y: 50,
    rotate: -10,
    transition: {
      type: "spring",
      bounce: 0.4,
      duration: 0.8
    }
  }
};

const textVariants = {
  hidden: { x: "-80%" },
  visible: {
    x: 0,
    transition: {
      type: "spring",
      bounce: 0.6,
      duration: 2
    }
  }
};

const hue = (h) => `hsl(${h}, 100%, 50%)`;

function Card({ image, name, desc, hueA, hueB }) {
  const background = `linear-gradient(306deg, ${hue(hueA)}, ${hue(hueB)})`;

  return (
    <motion.div
      className="card-container"
      initial="offscreen"
      whileInView="onscreen"
      viewport={{ once: true, amount: 0.8 }}
    >
      <div className="splash" style={{ background }} />

      <motion.div className="card-certificate" variants={cardVariants}>
        <img src={image} alt="Certificate" />
      </motion.div>
      <motion.div
        className="certification-details"
        variants={textVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true}}
      >
        <motion.h3>{name}</motion.h3>
        <motion.p>{desc}</motion.p>
      </motion.div>
    </motion.div>
  );
}

const food = [
  [
    "images/Udemy.jpg",
    "The Complete 2022 Web Development Bootcamp",
    "Udemy",
    340,
    10
  ],
  ["images/GLA.jpg", "Blockchain Basics", "Great Learning", 20, 40],
  ["images/infosys.png", "Blockchain 101", "Infosys Springboard", 60, 90]
];

export default function ThirdSection() {
  return (
    <div className="thirdSection">
      <span className="grey">Elevating skills.</span>
      <h1>Certifications</h1>
      <div className="main-container">
        {food.map(([image, name, desc, hueA, hueB], index) => (
          <Card
            image={image}
            name={name}
            desc={desc}
            hueA={hueA}
            hueB={hueB}
            key={image}
            custom={index}
          />
        ))}
      </div>
    </div>
  );
}
